import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ChooseLotteryModeProps {
    show: boolean;
    onHide: () => void;
    onPermsButtonClick: () => void;
}

const ChooseLotteryMode: React.FC<ChooseLotteryModeProps> = ({ show, onHide, onPermsButtonClick }) => {
    const { t } = useTranslation();
    const handlePermutationClick = () => {
        onPermsButtonClick();
    };

    const handleSingleLineClick = () => {
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} className="choose-lottery-mode">
            <Modal.Header closeButton />
            <Modal.Body className="content-container">
                <p>{t('playPicker.permsAndBankers.chooseLotteryModeInfo')}</p>
                <div className="buttons-container">
                    <button onClick={handlePermutationClick} className="btn-permutation" type="button">
                        {t('playPicker.permsAndBankers.permutation')}
                    </button>
                    <button onClick={handleSingleLineClick} className="btn-single-line" type="button">
                        {t('playPicker.permsAndBankers.singleLine')}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChooseLotteryMode;
